module.exports = __webpack_public_path__ + "img/work-in-progress.88a2104a.svg";